var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._l(_vm.fieldData.children, function (textItem, index) {
      return _c(
        "p",
        {
          directives: [{ name: "copy-text", rawName: "v-copy-text" }],
          key: index,
        },
        [
          _vm.rowData[textItem.fieldCode] === 0 ||
          _vm.rowData[textItem.fieldCode]
            ? _c(
                "span",
                { directives: [{ name: "copy-text", rawName: "v-copy-text" }] },
                [
                  _vm._v(
                    _vm._s(textItem.fieldName) +
                      _vm._s(_vm.rowData[textItem.fieldCode])
                  ),
                ]
              )
            : _c(
                "span",
                { directives: [{ name: "copy-text", rawName: "v-copy-text" }] },
                [_vm._v(_vm._s(textItem.fieldName) + "-")]
              ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }